import { c as _c } from "react/compiler-runtime";
interface ObstetricsIconProps {
  size?: number;
  className?: string;
}
const ObstetricsIcon = t0 => {
  const $ = _c(10);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t10;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M12.7686 13.0892C13.0323 13.4468 13.8023 13.8174 14.7733 12.4392C15.9871 10.7165 16.2691 8.85277 14.1509 7.10256C12.0327 5.35234 9.49158 6.39772 8.81413 7.72493C8.51115 8.31849 7.45927 10.3794 9.43649 13.0615" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />;
    t7 = <path d="M9.43603 13.0617C8.89044 14.5679 7.6951 17.6147 11.2735 20.0005C15.7734 23.0007 16.7739 19.0001 16.7739 19.0001" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />;
    t8 = <path d="M14.591 16.6176C15.129 15.6028 16.7846 14.141 18.5824 15.0146C19.963 15.6854 18.9446 17.9947 18.4238 18.4761C19.0384 18.2184 20.3239 17.8374 20.549 18.3744C20.8304 19.0456 19.6012 19.5609 17.7574 20.3338" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" strokeLinejoin="round" />;
    t9 = <path d="M15.2738 15.4995C15.236 14.6994 15.7739 12.4994 17.1731 12.3258C19.0437 12.0936 20.9908 11.9665 21.4987 10.5643C22.0857 8.94386 21.0249 7.83027 21.2874 6.09509" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />;
    t10 = <circle cx="14.0674" cy="14" r="11" stroke="currentColor" strokeWidth="1.2" />;
    $[2] = t10;
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
  } else {
    t10 = $[2];
    t6 = $[3];
    t7 = $[4];
    t8 = $[5];
    t9 = $[6];
  }
  let t11;
  if ($[7] !== t3 || $[8] !== t5) {
    t11 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}{t10}</svg>;
    $[7] = t3;
    $[8] = t5;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  return t11;
};
export default ObstetricsIcon;